import { Card, CardContent } from "@/components/ui/card";
import { Clock } from "lucide-react";

export function ChangeRequestsTab() {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-12">
        <div className="rounded-full bg-muted p-3 mb-4">
          <Clock className="h-8 w-8 text-muted-foreground" />
        </div>
        <h3 className="text-lg font-semibold mb-2">Coming Soon</h3>
        <p className="text-sm text-muted-foreground text-center max-w-md">
          Change Requests is part of Phase 2 and is currently under development.
        </p>
      </CardContent>
    </Card>
  );
}
